module.exports = __webpack_public_path__ + "img/sign-10.8e575948.jpg";